import routeNames from "./publicRouteNames.json";
export const RESERVED_TOP_LEVEL_BUSINESS_SLUGS = new Set([...routeNames.topLevel, ...routeNames.languages, ...routeNames.countries]);
export const isReservedBusinessSlug = (value) => {
  const slug = String(value || "").trim().toLowerCase();
  const [language, country, extra] = slug.split("-");
  return RESERVED_TOP_LEVEL_BUSINESS_SLUGS.has(slug) || (!extra && routeNames.languages.includes(language) && routeNames.countries.includes(country));
};
export const CONFUSING_BUSINESS_SLUGS = RESERVED_TOP_LEVEL_BUSINESS_SLUGS;

export const BUSINESS_SLUG_RE = /^[a-zA-Z0-9-_.]*$/;

export const normalizeBusinessSlug = (value) => {
  const raw = String(value || "").trim().toLowerCase();
  if (!raw) return "";

  const cleaned = raw.replace(/^\/+|\/+$/g, "");
  if (!cleaned) return "";

  const parts = cleaned.split("/").filter(Boolean);
  if (!parts.length) return "";

  return parts[0] === "b" && parts[1] ? parts[1] : parts[0];
};

export const hasValidBusinessSlugCharacters = (value) =>
  BUSINESS_SLUG_RE.test(String(value || ""));

export const getBusinessSlugAdvisory = (value) => {
  const slug = normalizeBusinessSlug(value);
  if (!slug || !isReservedBusinessSlug(slug)) return "";

  return `"${slug}" is reserved for Timely365. Please choose another booking link.`;
};
